<mat-card *ngIf="card.display == 'Summary'" style="min-height: 115px; max-height: 115px; display: flex; flex-direction: row; cursor: pointer; padding: 0" (click)="cardClick()">
  <div [ngClass]="isDisabled()" style="display: flex; flex-direction: column; flex: .25;">
    <img *ngIf="!card.disabled" style="display: block; margin: auto; height: 90px; max-width: 90px;" src="./assets/images/Card Fees and Billing.png">
    <img *ngIf="card.disabled" style="display: block; margin: auto; height: 90px; max-width: 90px;" src="./assets/images/Card Fees and Billing disabled.png">
  </div>
  <div style="display: flex; flex-direction: column; flex: 1;">
    <div class="robotoMedium" style="display: flex; flex-direction: row; padding: 5px; flex: .25; font-size: 12pt; align-items: flex-start;">
        <span translate>Fees & Billing</span>
    </div>
    <div *ngIf="!card.disabled" style="display: flex; flex-direction: row; flex: 1; justify-content: center; align-items: center;">
      <div [ngClass]="checkTotalString(totalString)" style="padding: 5px;font-size: 18pt;">
          {{totalString | translate}}<span style="padding-left: 5px">{{creditOrDue | translate}}</span>
      </div>
    </div>
    <!--If Disabled-->
    <div *ngIf="card.disabled" class="robotoMedium" style="display: flex; flex-direction: row; flex: 1; justify-content: center; align-items: center; font-size: 14pt; color: red">
      <div>
        {{card.disabledMessage | translate}}
      </div>
    </div>
  </div>
</mat-card>
<mat-card *ngIf="card.display == 'Detail'" style="min-height: 100px; padding: 0; display: flex; flex-direction: row;">
  <div style="display: flex; flex-direction: column; flex: 1">
    <div [ngClass]="isDisabled()" style="display: flex; flex-direction: row;">
      <div class="robotoMedium" style="color: white; padding: 10px; font-size: 14pt; display: flex; flex-direction: column; flex: 1;">
          <span translate>Fees & Billing</span>
      </div>
      <div style="display: flex; flex-direction: column; flex: 1; align-items: flex-end; justify-content: center">
        <button *ngIf="userType==2 && showPay == true" [disabled]="card.disabled" mat-stroked-button class="mat-card-button" (click)="payClick()"><span translate>Pay</span></button>
      </div>
      <div *ngIf="!card.disabled" style="display: flex; flex-direction: row; padding: 5px">
        <div style="display: flex; flex-direction: column; flex: 1; align-items: flex-end; justify-content: center">
          <button mat-stroked-button class="mat-card-button" (click)="viewDetailsClick()"><span translate>Go To Fees & Billing</span></button>
        </div>
      </div>
    </div>
    <div *ngIf="!card.disabled" style="display: flex; flex-direction: column; flex: 1">
      <table *ngIf="checkIfBalance()" mat-table [dataSource]="feesLedger" style="width: 100%">

        <!-- Code Column -->
        <ng-container matColumnDef="Code">
          <th mat-header-cell *matHeaderCellDef class="robotoMedium" style="font-size: 12pt; color: black"><span translate>Code</span></th>
          <td mat-cell *matCellDef="let entry" style="font-size: 10pt;"> {{entry.Code}} </td>
            <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>

        <!-- Description Column -->
        <ng-container matColumnDef="Description">
          <th mat-header-cell *matHeaderCellDef class="robotoMedium" style="font-size: 12pt; color: black"><span translate>Description</span></th>
          <td mat-cell *matCellDef="let entry" style="font-size: 10pt;"> {{entry.Description}} </td>
            <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>

        <!-- Balance Column -->
        <ng-container matColumnDef="Balance">
          <th mat-header-cell *matHeaderCellDef class="robotoMedium" style="font-size: 12pt; color: black; text-align: end; padding-right: 5px;"><span translate>Balance</span></th>
          <td mat-cell *matCellDef="let entry" style="font-size: 10pt; text-align: end; padding-right: 5px"> {{numberWithCommas(entry.Balance.toFixed(2))}}</td>
            <td  mat-footer-cell *matFooterCellDef>
                <div *ngIf="checkIfBalance()" style="display: flex;flex-direction: row;justify-content: flex-end;">
                    <div style="font-weight: 800;margin-top: 1px;"><span translate style="padding-right: 4px">Total</span></div>
                    <div style="display: flex; flex-direction: column; font-size: 11pt; padding-right:5px; padding-bottom: 2px; text-align: right" [ngClass]="checkTotalString(totalString)">{{totalString | translate}}</div>
                </div>
            </td>
        </ng-container>

        <!-- CreditOrDue Column -->
        <ng-container matColumnDef="CreditOrDue">
          <th mat-header-cell *matHeaderCellDef class="robotoMedium" style="font-size: 12pt; color: black; width: 10%"></th>
          <td mat-cell *matCellDef="let entry" style="font-size: 10pt;"> {{entry.DueorCredit | translate}} </td>
            <td mat-footer-cell *matFooterCellDef style="padding-bottom: 2px" [ngClass]="checkTotalString(totalString)">{{creditOrDue | translate}}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        <tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>
      </table>
      <div style="display: flex; flex-direction: row;flex: 1; padding: 15px; justify-content: center" *ngIf="!checkIfBalance()">{{totalString | translate}}</div>
    </div>
    <!--If Disabled-->
    <div *ngIf="card.disabled" class="robotoMedium" style="display: flex; flex-direction: row; flex: 1; justify-content: center; align-items: center; font-size: 14pt; color: red">
      <div style="padding: 50px;">
        {{card.disabledMessage | translate}}
      </div>
    </div>
  </div>
</mat-card>
